// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"modalWarning_modalContainer__r2_4U","contentContainer":"modalWarning_contentContainer__vMGmN","saveButton":"modalWarning_saveButton__kHkwd"};